// eslint-disable-next-line no-use-before-define
import React, { FC, useState } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import alertBodyTypes from 'modules/_shared/components/Alert/alertBodyTypes';
import { addAlert } from 'modules/_shared/redux/alertActions';
import { setModal } from 'modules/_shared/redux/modalActions';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import '../../Modals.scss';
import { AddCouncilFormState } from '../types/AddCouncilForm';

type UploadAnnouncementModalProps = {
  updateFormState: (updates: Partial<AddCouncilFormState>) => void;
};

const UploadAnnouncementModal: FC<UploadAnnouncementModalProps> = ({
  updateFormState,
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const [file, setFile] = useState<File>();

  const handleAnnouncementFileChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (e.target.files?.[0]) {
      updateFormState({
        announcementFile: e.target.files[0],
        isUploadModalVisible: false,
      });
    }
  };

  const handleDrop = (event: any) => {
    event.preventDefault();
    const files = [...event.dataTransfer.files];
    if (files.length > 1) {
      Swal.fire({
        icon: 'info',
        title: `<h4 class="nk-modal-title">${t('MustUploadOneDocument')} </h4>`,
        confirmButtonText: t('Ok'),
        confirmButtonColor: '#6576ff',
        allowOutsideClick: false,
      });
    } else {
      Swal.fire({
        icon: 'info',
        title: `<h4 class="nk-modal-title">${t(
          'WantUploadThisDocument'
        )} </h4>`,
        confirmButtonText: t('Upload'),
        confirmButtonColor: '#6576ff',
        allowOutsideClick: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          setFile(files[0]);
        }
      });
    }
  };

  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  const handleChooseDocument = (event: any) => {
    event.preventDefault();
    const file = event.target.files[0];

    Swal.fire({
      icon: 'info',
      title: `<h4 class="nk-modal-title">${t('WantUploadThisDocument')} </h4>`,
      confirmButtonText: t('Upload'),
      confirmButtonColor: '#6576ff',
      allowOutsideClick: false,
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        setFile(file);
      }
    });
  };

  const saveDocument = (event: any) => {
    event.preventDefault();
    if (file) {
      handleAnnouncementFileChange(event);
      updateFormState({ isUploadModalVisible: false });
    }
  };

  return (
    <>
      <Modal.Header>
        <h5 className="modal-title">{t('UpdateAnnouncement')}</h5>
        <a
          className="close cursor-pointer"
          onClick={() => {
            dispatch(addAlert(alertBodyTypes.BOARD_UPDATED));
            dispatch(setModal(null));
          }}
        >
          <em className="icon ni ni-cross" />
        </a>
      </Modal.Header>

      <Modal.Body>
        <form className="form-validate is-alter" onSubmit={saveDocument}>
          <div className="form-group">
            <label className="form-label" htmlFor="default-06">
              {t('YouHaveModifiedTheBoard')}
            </label>
            <div
              className="nk-block-head-content"
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <div onDrop={handleDrop} onDragOver={handleDragOver}>
                <div className="card card-bordered sp-plan">
                  <div
                    className="sp-plan-action card-inner"
                    style={{
                      height: '10px',
                      width: '460px',
                    }}
                  >
                    <div>
                      <span className="text-center w-300px d-block text-ellipsis">
                        {file?.name || t('DragDocumentToUpload')}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <input
                type="file"
                id="fileInput"
                style={{ display: 'none' }}
                onChange={handleChooseDocument}
                accept=".pdf"
              />
              <label
                htmlFor="fileInput"
                className="btn btn-light"
                style={{ marginBottom: '0px' }}
              >
                {t('Choose')}
              </label>
            </div>
          </div>
          <button
            type="submit"
            className="btn btn-lg btn-primary"
            disabled={!file}
          >
            {t('Accept')}
          </button>
        </form>
      </Modal.Body>
    </>
  );
};

export default UploadAnnouncementModal;
